angular.module('storefrontApp')
    .component('rsSizingChart', {
        templateUrl: 'themes/assets/js/common-components/rsSizingChart.tpl.html',
        bindings: {
            productId: '@',
        },
        controller: ['rsSizingChartService', 'dialogService', function (sizingChartService, dialogService) {
            const ctrl = this;

            ctrl.showSizingChartForm = function () {
                sizingChartService.getSizingChart(ctrl.productId)
                    .then(function (response) {
                        const charts = response.data;
                        let chart = null;

                        if (charts.length > 0) {
                            chart = charts[0];
                            chart.sizes = _.sortBy(chart.sizes, (x) => x.length);
                        }

                        // Open through $uibModal (dialogService) so the popup inherits the
                        // platform focus trap, return-focus-on-close and Escape handling
                        // shared by every other dialog (WCAG 2.4.3, #892).
                        dialogService.showDialog(
                            { chart },
                            'sizingChartDialogController',
                            'storefront.sizing-chart-dialog.tpl',
                        );
                    });
            };

            this.$onDestroy = function () {};
        }],
    })

    .controller('sizingChartDialogController', [
        '$scope',
        '$uibModalInstance',
        'dialogData',
        function ($scope, $uibModalInstance, dialogData) {
            $scope.chart = dialogData.chart;

            $scope.close = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }]);
